import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const WordTitle = ({ lines, className = "", delay = 0, mode = "view" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px 0px" });
  const active = mode === "mount" ? true : inView;
  let w = 0;
  return (
    <span ref={ref} className={`block ${className}`}>
      {lines.map((line, li) => (
        <span key={li} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <span className="block">
            {line.split("*").map((seg, si) => {
              const italic = si % 2 === 1;
              return seg
                .split(" ")
                .filter(Boolean)
                .map((word, wi) => {
                  const idx = w++;
                  return (
                    <motion.span
                      key={`${li}-${si}-${wi}`}
                      className={`inline-block ${italic ? "font-serif italic font-medium text-[#C5A059]" : ""}`}
                      initial={{ y: "120%", opacity: 0 }}
                      animate={active ? { y: "0%", opacity: 1 } : { y: "120%", opacity: 0 }}
                      transition={{ duration: 1.3, delay: delay + idx * 0.08, ease: [0.19, 1, 0.22, 1] }}
                    >
                      {word}
                      {"\u00A0"}
                    </motion.span>
                  );
                });
            })}
          </span>
        </span>
      ))}
    </span>
  );
};

export const UpTitle = ({ text, className = "" }) => (
  <p className={`font-serif text-lg md:text-xl uppercase tracking-[0.05em] text-zinc-300 ${className}`}>
    {text.split("*").map((seg, i) =>
      i % 2 === 1 ? (
        <em key={i} className="italic text-[#C5A059] normal-case tracking-normal">
          {seg}
        </em>
      ) : (
        <span key={i}>{seg}</span>
      )
    )}
  </p>
);
